webpackJsonp([81],{

/***/ 1345:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = makeRule;
/*
 * 根据给定的多个文件路径引入模块
 * @Author: anker.wang
 * @Date: 2018-01-08 11:23:04
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-07-26 12:37:26
 */

/**
 * 快速制作验证规则
 * https://github.com/yiminghe/async-validator
 * @param {*} message
 * @param {*} type
 * @param {*} trigger
 * @param {*} required
 *
 string: Must be of type string. This is the default type.
 number: Must be of type number.
 boolean: Must be of type boolean.
 method: Must be of type function.
 regexp: Must be an instance of RegExp or a string that does not generate an exception when creating a new RegExp.
 integer: Must be of type number and an integer.
 float: Must be of type number and a floating point number.
 array: Must be an array as determined by Array.isArray.
 object: Must be of type object and not Array.isArray.
 enum: Value must exist in the enum.
 date: Value must be valid as determined by Date
 url: Must be of type url.
 hex: Must be of type hex.
 email: Must be of type email.
 */
function makeRule(message) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'string';
  var trigger = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'blur';
  var required = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

  var rule = { message: message, type: type, trigger: trigger, required: required };
  rule.transform = function (value) {
    // 为空字符串时转换为null
    value === '' && (value = null);
    // 数字类型忽略为null的数字转换
    if (value !== null && ['number', 'integer', 'float'].includes(type)) {
      value = Number(value);
    }
    return value;
  };
  return rule;
}

/***/ }),

/***/ 1823:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return searchRules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return formRules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return editCustomerFormRules; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__ = __webpack_require__(1345);



var searchRules = {
  id: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入正确的智能外呼ID', 'integer', 'blur', false), { min: 1 })]
};

var formRules = {
  title: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入智能外呼名称', 'string'))],
  customer_id: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择客户', 'integer'))],
  project_id: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择项目', 'integer'))],
  robot_tpl: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入外呼模板', 'string'))],
  retry_times: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入未拨打重试次数', 'string'))],
  retry_duration: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入未拨打重试间隔', 'string'))],
  file: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请导入客户信息', 'object'))]
};

var editCustomerFormRules = {
  title: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入智能外呼名称', 'string'))],
  customer_id: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择客户', 'integer'))],
  project_id: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择项目', 'integer'))],
  robot_tpl: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入外呼模板', 'string'))],
  retry_times: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入未拨打重试次数', 'string'))],
  retry_duration: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入未拨打重试间隔', 'string'))],
  file: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请导入客户信息', 'object'))]
};

/***/ }),

/***/ 2731:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__intelligent_outbound_call_rules_js__ = __webpack_require__(1823);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  data: function data() {
    return {
      id: 0,
      formRules: filter.copyJson(__WEBPACK_IMPORTED_MODULE_1__intelligent_outbound_call_rules_js__["b" /* formRules */]),
      form: {
        title: '',
        customer_id: '',
        project_id: '',
        robot_tpl: '',
        retry_times: '',
        retry_duration: '',
        file: null
      }
    };
  },

  computed: {},
  watch: {},
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      return vm.onLoad();
    });
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    this.onReload();
    next();
  },
  created: function created() {},
  mounted: function mounted() {},

  methods: {
    onLoad: function onLoad() {
      if (this.$route.params.id) {
        this.setForm(this.id = this.$route.params.id);
        delete this.formRules.file;
      }
    },
    onReload: function onReload() {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.$data, this.$options.data.call(this));
      this.onLoad();
    },
    setForm: function setForm(id) {
      var _this = this;

      request.page('getIntelligentOutboundCallDetail', { id: id }).then(function (_ref) {
        var data = _ref.data;

        filter.setLoop(_this.form, data);
        _this.form.customer_id = String(_this.form.customer_id);
        _this.form.project_id = String(_this.form.project_id);
        _this.form.retry_times = String(_this.form.retry_times);
        _this.form.retry_duration = String(Number(_this.form.retry_duration) / 60);
      });
    },
    getForm: function getForm() {
      var formData = new FormData();
      formData.append('title', this.form.title);
      formData.append('robot_tpl', this.form.robot_tpl);
      formData.append('customer_id', this.form.customer_id);
      formData.append('project_id', this.form.project_id);
      formData.append('retry_times', this.form.retry_times);
      formData.append('retry_duration', this.form.retry_duration * 60);
      if (this.form.file) {
        formData.append('file', this.form.file);
      }
      return formData;
    },
    onSubmit: function onSubmit() {
      var _this2 = this;

      this.form.customer_id = Number(this.form.customer_id);
      this.form.project_id = Number(this.form.project_id);
      this.$refs['form'].validate(function (valid) {
        if (valid) {
          _this2.id ? _this2.update(_this2.id) : _this2.create();
        } else {
          _this2.$message.error('提交内容填写不正确！');
        }
      });
    },
    create: function create() {
      var _this3 = this;

      request.common('createIntelligentOutboundCallData', this.getForm()).then(function (res) {
        _this3.$confirm(_this3.$route.meta.title + '成功, 是否继续添加？', '提示', { type: 'success' }).then(function () {
          _this3.$refs.form.resetFields();
        }, function () {
          _this3.$router.push({ path: '/intelligent-outbound-call/table/' });
        });
      });
    },
    update: function update(id) {
      var _this4 = this;

      var formData = this.getForm();
      request.common('updateIntelligentOutboundCallData', { id: id, formData: formData }).then(function (res) {
        _this4.$confirm(_this4.$route.meta.title + '成功, 是否前往列表页面？', '提示', { type: 'success' }).then(function () {
          _this4.$router.push({ path: '/intelligent-outbound-call/table/' });
        });
      });
    },
    uploadRequest: function uploadRequest(obj) {
      this.form.file = obj.file;
    },
    handleRemove: function handleRemove() {
      this.form.file = null;
    },
    customerRemoteMethod: function customerRemoteMethod(query) {
      return request.common('getCustomerTable', { keyword: query.name });
    },
    getCustomerInfoRemote: function getCustomerInfoRemote() {
      return request.common('getCustomerDetail', { id: this.form.customer_id });
    },
    customerLabel: function customerLabel(item) {
      return item.name + '/' + item.number;
    },
    projectRemoteMethod: function projectRemoteMethod(query) {
      return request.common('getProjectTable', { keyword: query.name, customerid: this.form.customer_id });
    },
    getProjectInfoRemote: function getProjectInfoRemote() {
      return request.common('getProjectDetail', { id: this.form.project_id });
    },
    onExportDemo: function onExportDemo() {
      request.common('robotcallSetting').then(function (_ref2) {
        var data = _ref2.data;

        window.location.href = data.demo_file_create_calltask;
      });
    }
  }
});

/***/ }),

/***/ 297:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IntelligentOutboundCallForm_vue__ = __webpack_require__(2731);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0bafe9a0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IntelligentOutboundCallForm_vue__ = __webpack_require__(4265);
function injectStyle (ssrContext) {
  __webpack_require__(4259)
  __webpack_require__(4261)
  this["$style"] = __webpack_require__(4263)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0bafe9a0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IntelligentOutboundCallForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0bafe9a0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IntelligentOutboundCallForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 4259:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4260);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("fc00b8fa", content, true, {});

/***/ }),

/***/ 4260:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"IntelligentOutboundCallForm.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 4261:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4262);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("3200c822", content, true, {});

/***/ }),

/***/ 4262:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"IntelligentOutboundCallForm.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 4263:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4264);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("622c4179", content, true, {});

/***/ }),

/***/ 4264:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"IntelligentOutboundCallForm.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 4265:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":"/"}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',{attrs:{"to":"/intelligent-outbound-call/table"}},[_vm._v("智能外呼列表")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('layout-panel',[_c('span',{attrs:{"slot":"header"},slot:"header"},[_vm._v("表单")]),_vm._v(" "),_c('el-form',{ref:"form",attrs:{"model":_vm.form,"rules":_vm.formRules,"size":"medium","label-width":"140px"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.onSubmit()}}},[_c('div',{staticClass:"re-el-form__flex"},[_c('div',{staticClass:"medium"},[_c('el-form-item',{attrs:{"label":"任务描述","prop":"title"}},[_c('el-input',{model:{value:(_vm.form.title),callback:function ($$v) {_vm.$set(_vm.form, "title", $$v)},expression:"form.title"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"客户","prop":"customer_id"}},[_c('remote-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","remote":"","clearable":"","id-key":"number","keyword-key":"name","label":_vm.customerLabel,"value-key":"id","placeholder":"请输入客户名称/编号搜索","query-request":_vm.customerRemoteMethod,"find-request":_vm.getCustomerInfoRemote},on:{"change":function($event){_vm.form.project_id=null}},model:{value:(_vm.form.customer_id),callback:function ($$v) {_vm.$set(_vm.form, "customer_id", $$v)},expression:"form.customer_id"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"项目","prop":"project_id"}},[_c('remote-select',{staticClass:"width-max",attrs:{"disabled":!_vm.form.customer_id,"clearable":"","id-key":"number","label-key":"name","value-key":"id","placeholder":"请输入项目名称/编号搜索","query-request":_vm.projectRemoteMethod,"find-request":_vm.getProjectInfoRemote},model:{value:(_vm.form.project_id),callback:function ($$v) {_vm.$set(_vm.form, "project_id", $$v)},expression:"form.project_id"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"外呼模板","prop":"robot_tpl"}},[_c('el-input',{model:{value:(_vm.form.robot_tpl),callback:function ($$v) {_vm.$set(_vm.form, "robot_tpl", $$v)},expression:"form.robot_tpl"}}),_vm._v(" "),_c('span',{staticStyle:{"font-size":"12px","color":"#999"}},[_vm._v("外呼模板为百度智能外呼平台标识项，如有疑问请联系产品技术部同事")])],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"未拨打重试次数","prop":"retry_times"}},[_c('el-input',{model:{value:(_vm.form.retry_times),callback:function ($$v) {_vm.$set(_vm.form, "retry_times", $$v)},expression:"form.retry_times"}},[_c('span',{attrs:{"slot":"suffix"},slot:"suffix"},[_vm._v("次")])])],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"未拨打重试间隔","prop":"retry_duration"}},[_c('el-input',{model:{value:(_vm.form.retry_duration),callback:function ($$v) {_vm.$set(_vm.form, "retry_duration", $$v)},expression:"form.retry_duration"}},[_c('span',{attrs:{"slot":"suffix"},slot:"suffix"},[_vm._v("分钟")])])],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"客户信息导入","prop":"file"}},[_c('el-upload',{staticClass:"upload-demo",attrs:{"drag":"","limit":1,"accept":".xlsx,.xls","on-remove":_vm.handleRemove,"http-request":_vm.uploadRequest,"action":"https://jsonplaceholder.typicode.com/posts/","multiple":""},model:{value:(_vm.form.file),callback:function ($$v) {_vm.$set(_vm.form, "file", $$v)},expression:"form.file"}},[_c('i',{staticClass:"el-icon-upload"}),_vm._v(" "),_c('div',{staticClass:"el-upload__text"},[_vm._v("将文件拖到此处，或"),_c('em',[_vm._v("点击上传")]),_vm._v(" 只能上传xlsx,xls文件")]),_vm._v(" "),_c('div',{staticClass:"el-upload__tip",attrs:{"slot":"tip"},slot:"tip"},[_c('span',[_vm._v("Excel需要包含表头[任务ID，姓名，电话，变量字段]变量字段为百度智能外呼平台设置项。任务ID，姓名，电话不得为空。")]),_vm._v(" "),_c('el-button',{attrs:{"type":"text","size":"mini"},on:{"click":_vm.onExportDemo}},[_vm._v("下载Demo\n                ")])],1)])],1)],1)]),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary","native-type":"submit"}},[_vm._v("提交\n        ")]),_vm._v(" "),_c('el-button',{on:{"click":_vm.onReload}},[_vm._v("取消")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/intelligent-outbound-call-form.35dcee66e0034c9e9853.js